import { render, staticRenderFns } from "./DetailBanners.vue?vue&type=template&id=535892e4&scoped=true"
import script from "./DetailBanners.vue?vue&type=script&lang=js"
export * from "./DetailBanners.vue?vue&type=script&lang=js"
import style0 from "./DetailBanners.vue?vue&type=style&index=0&id=535892e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535892e4",
  null
  
)

export default component.exports